module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if (data.length === 0) { 
    ; __append("\r\n    <tr> <td colspan=\"2\"> ")
    ; __append(escapeFn(emptyTitle))
    ; __append(" </td> </tr>\r\n")
    ;  } else {
    for (i=0,len=data.length ; i<len ; i++) { 
        item = data[i]; 
    ; __append("\r\n    <tr>\r\n        <td>\r\n            <span class=\"content\">\r\n                ")
    ; __append(escapeFn(item.name))
    ; __append("\r\n            </span>\r\n        </td>\r\n        <td>\r\n            <select class=\"setting\" data-object-id=\"")
    ; __append(escapeFn(item.id))
    ; __append("\">\r\n                ")
    ; options.forEach(function(option){
                
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn(option.value))
    ; __append("\" ")
    ; __append(escapeFn((item.state === option.value) ? 'selected="selected"' : ''))
    ; __append(" >")
    ; __append(escapeFn(option.label))
    ; __append("</option>\r\n                ")
    ; 
                })
    ; __append("\r\n            </select>\r\n        </td>\r\n    </tr>\r\n")
    ;  }} 
  }
  return __output;

}